import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import MassModalWindow from './common/MassModalWindow'

import { setReviewModalOpen, selectReviewIsModalOpen, selectReviewModalType } from 'state/review'

interface ModalWindowProps {
    handleRejectTagChange: any
}

const ModalWindow: React.FC<ModalWindowProps> = ({ handleRejectTagChange }) => {
    const dispatch = useDispatch()
    const modalType = useSelector(selectReviewModalType)
    const isModalOpen = useSelector(selectReviewIsModalOpen)
    const setModalOpen = (isOpen: boolean) => {
        dispatch(setReviewModalOpen(isOpen))
    }

    // Support modalType
    // case 'batchSubmissionsReviewed':
    // case 'batchSubmissionsDisplayedSoon':
    // case 'batchBudgetUsedUp':
    // case 'batchAboutWaitingList':
    // case 'batchWhenWillSeeWaitingList':
    // case 'batchSingleReject'
    // case 'singleReject'
    return (
        <MassModalWindow
            type={modalType}
            isOpenModal={isModalOpen}
            setModalOpen={setModalOpen}
            handleRejectTagChange={handleRejectTagChange}
        />
    )
}

export default ModalWindow
